import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

export enum DialogOptions {
    UNDEFINED = 'undefined',
    CREATE = 'create',
    DUPLICATE = 'duplicate',
    EDIT = 'edit',
    DELETE = 'delete',
}

@Component({
    selector: 'app-simple-overlay',
    templateUrl: './simple-overlay.component.html',
    styleUrl: './simple-overlay.component.css',
    standalone: false,
})
export class SimpleOverlayComponent {
    readonly CREATE = DialogOptions.CREATE;
    readonly DUPLICATE = DialogOptions.DUPLICATE;
    readonly EDIT = DialogOptions.EDIT;
    readonly DELETE = DialogOptions.DELETE;

    @ViewChild('dialog') dialogElement: ElementRef;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            options: DialogOptions[];
        },
        private dialogRef: MatDialogRef<SimpleOverlayComponent>
    ) {}

    async selectOption(option: DialogOptions) {
        this.dialogRef.close(option);
    }

    getOptionText(option: DialogOptions) {
        if (option == DialogOptions.EDIT) return 'mimic-drawing.layers.edit';
        else return;
    }
}
